<template>
     <div>
    <!-- Navbar -->
    <nav
     
      :class="{'navbar navbar-expand navbar-light bg-solimano pt-0 pb-3 px-2' : !isMobile , 'd-block navbar navbar-expand navbar-light bg-solimano py-0 px-2' : isMobile}"
    >
      <!-- Container wrapper -->
      <div class="container-fluid">
        <!-- Toggle button -->
        <button
          class="navbar-toggler"
          type="button"
          data-mdb-toggle="collapse"
          data-mdb-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <i class="fas fa-bars"></i>
        </button>
 
        <!-- Collapsible wrapper -->
        <div class="collapse navbar-collapse  mx-auto" id="navbarSupportedContent" >
          <!-- Navbar brand -->
          <figure class="mt-2 mb-0" :class="{'mx-auto' : isMobile}">
            <img
              src="@/assets/footer/empresasWhite.png"
              height="20"
              width="200"
              alt="MDB Logo"
            />
          </figure>
        </div>
     
 
       
 
         
          <div v-if="!isMobile" class=" text-white tamaño mt-4">
           
            © GRUPO SOLIMANO S.A.C - Todos los derechos reservados | Autor: Tecnología de la información
          </div>
        </div>
 
        <div v-if="isMobile" class=" text-white tamaño  text-center pb-2">
           
           © GRUPO SOLIMANO S.A.C - Todos los derechos reservados | Autor: Tecnología de la información
        </div>
        <!-- Right elements -->
      <!-- Container wrapper -->
    </nav>
    <!-- Navbar -->
  </div>
</template>
 
<script>
export default {
    name: 'SolimanologFooter',
 
    data() {
        return {
          isMobile: false,
 
        };
    },
 
    mounted() {
      this.checkIfMobile();
    window.addEventListener("resize", this.checkIfMobile);
    },
 
    methods: {
      checkIfMobile() {
      this.isMobile = window.innerWidth <= 768; // Ajusta el ancho según tus necesidades
    },
    },
};
</script>
 
<style  scoped>
 
.bg-solimano {
  background: #002c5d;
}
.perfiles-user {
  font-size: 0.67rem;
}
 
.tamaño{
  font-size: 0.5rem;
}
 
</style>